import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const Equipment = React.lazy(async () => ({
    default: (await import('@oc/equipment/module')).EquipmentModule
}))

export function EquipmentComponent() {
    return <SuspenseWhileLoading LazyComponent={Equipment} />
}
